import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function RecruitmentCountryList() {
  const navigate = useNavigate();
  const columns = [
    { field: "RC_Id", label: "#" },
    { field: "RC_CountryName", label: "Recruitment Country" },
    { field: "RC_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();
 
  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.RC_Id));

        navigate(
          `/RecruitmentCountryLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/RecruitmentCountry/list`}
      actions={actions}
      title={`Recruitment Country`}
      linkvalue={`/RecruitmentCountryLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default RecruitmentCountryList;
